export const appsCatalogItemsDatatable = "/apps/catalog_items_datatable";
